export const locationsUS = ['centralus', 'eastus', 'eastus2', 'westus', 'northcentralus', 'southcentralus', 'westcentralus', 'westus2', 'westus3'];
